import { defineStore } from 'pinia';
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";
import { sDs } from '@common/sDs/sDs';

let saveNavigationParamsTimeout = false;
let prevSavedViewes = false;

let navigationStoreOptions = {
    state: () => ({
        views: {},
        history: [],
        mainGridReload: false,
        showInComponents: [
            'workflowViewer',
            'profile'
        ],
        allowedButtons: ['min', 'popup', 'window'],
        availableNavigations: {},
        projectWithRouter: false,
        allAvailablePaths: [
            {
                name: /^changeMyUserInfo/gi,
                title: 'Change User Information',
                staticProps: "class=MainGrid&MenuArea_act=changeMyUserInfo&processedClass=MenuArea",
                width: 500,
                height: 450
            },
            {
                name: /^changeMyRole/gi,
                title: 'Switch User Role',
                staticProps: "class=MainGrid&MenuArea_act=changeMyRole&processedClass=MenuArea",
                width: 500,
                height: 450
            },
            {
                name: /^myInfo/gi,
                title: 'Edit my organization',
                staticProps: "class=MainGrid&MenuArea_act=myInfo&processedClass=MenuArea",
                width: 800,
                height: 600
            },
            {
                name: /^changeMyInfo/gi,
                title: 'Choose my organization',
                staticProps: "class=MainGrid&MenuArea_act=changeMyInfo&processedClass=MenuArea",
                width: 500,
                height: 500
            },
            {
                name: /^ShareRecord/gi,
                title: 'Record Sharing and Transfer',
                staticProps: "class=MainGrid",
                dynamicProps: {
                    'act': {
                        title: 'Action',
                        required: true,
                        type: 'dropdown',
                        items: [
                            { text: 'share', value: 'share' },
                            { text: 'unshare', value: 'unshare' },
                        ]
                    },
                    'perspectiveID': {
                        title: 'Perspective',
                        required: true,
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer', value: 1 },
                            { text: 'Opportunity', value: 2 },
                            { text: 'Organization', value: 3 },
                        ]
                    },
                    'MainGrid_selectedID[]': 1
                },
                width: 1000,
                height: 570
            },
            {
                name: /^CustomAttributeManager/gi,
                title: 'User defined fields',
                staticProps: "class=MainGrid&MenuArea_act=customAttr&processedClass=MenuArea",
                dynamicProps: {
                    'perspectiveID': 1
                },
                width: 800,
                height: 530
            },
            {
                name: /^AdminProfile/gi,
                title: 'Administrative Options',
                staticProps: "classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'activeTab': 1
                },
                width: 1400,
                height: 750
            },
            {
                name: /^emailAlertWizzard/gi,
                title: 'Automation Profile',
                staticProps: "act=edit&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'act': ['new', 'edit'],
                    'prevTab': 1,
                    'AutomationID': 1
                },
                width: 685,
                height: 700,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^SignInProfile/gi,
                title: 'Sign-In Profile',
                staticProps: "classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'act': ['new', 'edit'],
                    'prevTab': 1,
                    'signInStationID': 1
                },
                width: 950,
                height: 600,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^NewPackage/gi,
                title: 'New Survey',
                staticProps: "act=new&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^EditPackage/gi,
                title: 'Edit Survey',
                staticProps: "act=edit&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1,
                    'surveyID': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^NewWaiver/gi,
                title: 'New Waiver',
                staticProps: "act=new&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^EditWaiver/gi,
                title: 'Edit Waiver',
                staticProps: "act=edit&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1,
                    'waiverID': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^NewTraining/gi,
                title: 'New Training',
                staticProps: "act=new&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            {
                name: /^EditTraining/gi,
                title: 'Edit Training',
                staticProps: "act=edit&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1,
                    'trainingID': 1
                },
                width: 1100,
                height: 935,
                reloadWindows: ['AdminProfile']
            },
            /* {
                name: 'EditLoggedData',
                // title: 'DD.ADMIN_OPTIONS.ADMINOPTIONS_TITLE',
                staticProps: "act=edit&classPath=common&class=TabControl&tabList=AdminOptionProfile",
                dynamicProps: {
                    'prevTab': 1,
                    'surveyID': 1
                }
            }, */
            {
                name: /^CustomizeGrid/gi,
                title: 'Grid Settings',
                staticProps: "act=customizeGrid&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                    'cgSavedGridID': 1
                },
                width: 1015,
                height: 800,
                reloadMainGrid: true
            },
            {
                name: /^customizeSort/gi,
                title: 'Sort Grid Columns',
                staticProps: "act=customizeSort&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1
                },
                width: 600,
                height: 600,
                reloadMainGrid: true
            },
            {
                name: /^Filter_Manager/gi,
                title: 'Filters',
                staticProps: "act=filter&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1
                },
                width: 800,
                height: 600,
                reloadMainGrid: true
            },
            {
                name: /^EditFilter/gi,
                title: 'Edit Filter',
                staticProps: "classPath=kernel&className=FilterManager",
                dynamicProps: {
                    'act': {
                        default: 'new'
                    },
                    'perspectiveID': 1,
                    'filterID': {
                        default: -1
                    },
                    'isLogBook': 1
                },
                reloadWindows: ['Filter_Manager'],
                width: 1000,
                height: 750
            },
            /* {
                name: 'report',
                // title: 'DD.SCHEDULE_CALENDAR.SCHEDULECALENDAR_TITLE',
                staticProps: "class=MainGrid&MenuArea_act=VolunteerProfileReport;1;0;1&processedClass=MenuArea",
                dynamicProps: {
                    'perspectiveID': 1,
                    'MainGrid_selectedID[]': 1
                    // select report
                }
            }, */
            {
                name: /^calendar/gi,
                title: 'Calendar',
                staticProps: "act=calendar&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 1718,
                height: 1024
            },
            {
                name: /^newProfile/gi,
                title: 'New Profile',
                staticProps: "act=new&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                },
                width: 800,
                height: 800,
                reloadMainGrid: true
            },
            {
                name: /^editProfile/gi,
                title: 'Edit Profile',
                staticProps: "act=edit&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 800,
                height: 800,
                reloadMainGrid: true
            },
            {
                name: /^PlaceManager/gi,
                title: 'Placement',
                staticProps: "act=place&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 1300,
                height: 700
            },
            {
                name: /^Logbook/gi,
                title: 'Logbook',
                staticProps: "class=MainGrid",
                dynamicProps: {
                    'act': ['logbook_selected', 'logbook_grid', 'logbook_acc'],
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 1004,
                height: 600
            },
            {
                name: /^LBELBGridSettings/gi,
                title: 'LBE Grid Settings',
                staticProps: "class=LogBook&classPath=logbook/&act=showSettings",
                dynamicProps: {
                    'perspectiveID': 1,
                    'cgSavedGridID': 1
                },
                width: 1200,
                height: 900,
                reloadWindows: ['Logbook']
            },
            {
                name: /^LBEFilter_Manager/gi,
                title: 'Filters',
                staticProps: "act=filter&class=LogBook&classPath=logbook/",
                dynamicProps: {
                    'perspectiveID': 1
                },
                width: 800,
                height: 600,
                reloadWindows: ['Logbook']
            },
            {
                name: /^LBEnewLBE/gi,
                title: 'LBE',
                staticProps: "class=LogBook&classPath=logbook/&act=edit",
                dynamicProps: {
                    'perspectiveID': 1,
                    'LogBook1[]': 1
                },
                width: 680,
                height: 500,
                reloadWindows: ['Logbook']
            },

            {
                name: /^LBELogBookApproval/gi,
                title: 'LBE Approval',
                staticProps: "class=LogBook&classPath=logbook/&act=approve",
                dynamicProps: {
                    'perspectiveID': 1,
                    'LogBook1[]': 1
                },
                width: 680,
                height: 500
            },
            {
                name: /^LBEhistory/gi,
                title: 'LBE History',
                staticProps: "class=LogBook&classPath=logbook/&act=history",
                dynamicProps: {
                    'perspectiveID': 1,
                    'LogBook1[]': 1
                },
                width: 750,
                height: 500
            },
            {
                name: /^LBEbulkEmail/gi,
                title: 'Email',
                staticProps: "act=email&class=LogBook&classPath=logbook/",
                dynamicProps: {
                    'perspectiveID': 1,
                    'LogBook1[]': 1
                },
                width: 920,
                height: 700
            },
            {
                name: /^LBEAutomations/gi,
                title: 'Automations',
                staticProps: "class=LogBook&classPath=logbook/",
                dynamicProps: {
                    'act': ['automation_grid', 'automation_selected', 'automation_acc'],
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 860,
                height: 500
            },
            {
                name: /^BulkEmail/gi,
                title: 'Email',
                staticProps: "act=email&class=MainGrid",
                dynamicProps: {
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 920,
                height: 700
            },
            {
                name: /^emailQueue/gi,
                title: 'Email Queue',
                staticProps: "act=emailQueue&classPath=kernel&class=BulkEmail",
                dynamicProps: {
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 1250,
                height: 770
            },
            {
                name: /^Automations/gi,
                title: 'Automations',
                staticProps: "class=MainGrid",
                dynamicProps: {
                    'act': ['automation_grid', 'automation_selected', 'automation_acc'],
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 860,
                height: 500
            },
            {
                name: /^newLBE/gi,
                title: 'Record Logbook Entry',
                staticProps: "class=MainGrid",
                dynamicProps: {
                    'act': ['new_logbook_lbe', 'new_logbook_waiver', 'new_logbook_training'],
                    'perspectiveID': 1,
                    'selectedID': 1
                },
                width: 680,
                height: 400
            },
        ],
        crc: false,
        additionalParams: {}
    }),
    getters: {
        getViews(state) {
            return () => state.views;
        },
    },
    actions: {
        findPath(winName) {
            let isFind = this.allAvailablePaths.find((tmp) => new RegExp(tmp.name).test(winName));
            if (!isFind) {
                errorHandler.handle(winName, { messageSubject: "Navigation not found" });
            }
            return isFind;
        },
        processSubmit(winName, width, height, winParams, fromWindow, formObj, addAsChildToWin, showOnDiffPage, fromWinName) {
            if (typeof fromWinName === 'string' && fromWinName.startsWith('Logbook')) {
                winName = 'LBE' + winName;
            }
            let foundedPath = this.findPath(winName);
            if (foundedPath) {
                let newView = {
                    windowName: winName,
                    width: width,
                    height: height
                };
                for (let hiddenInputName in foundedPath.dynamicProps) {
                    if (formObj?.[hiddenInputName]?.length) {
                        let tmpSel = [];
                        for (let i in formObj[hiddenInputName]) {
                            if (formObj[hiddenInputName][i].checked) {
                                tmpSel.push(formObj[hiddenInputName][i].value);
                            }
                        }
                        if (tmpSel.length) {
                            newView[hiddenInputName] = tmpSel.join(',');
                            newView.windowName += tmpSel.join(',');
                        }
                    }
                    if (formObj?.[hiddenInputName]?.value && formObj?.[hiddenInputName]?.value !== 'undefined') {
                        newView[hiddenInputName] = formObj[hiddenInputName].value;
                        newView.windowName += formObj[hiddenInputName].value;
                    } else if (foundedPath.dynamicProps[hiddenInputName].default) {
                        newView[hiddenInputName] = foundedPath.dynamicProps[hiddenInputName].default;
                        newView.windowName += foundedPath.dynamicProps[hiddenInputName].default;
                    }
                }
                let newViewId = this.createView(newView, false, false);
                // open in new window if the previous opened in new window
                let openInType = this.views?.[fromWinName]?.openedIn === 'window' ? 'window' : 'popup';
                this.openIn(newViewId, openInType);
            }
        },
        reloadPrevWindow(fromWinName, theForm) {
            let foundedPath = this.findPath(fromWinName);
            if (foundedPath && Array.isArray(foundedPath?.reloadWindows)) {
                let winRegexp = new RegExp(library.escapeRegExp(foundedPath.reloadWindows.join('|')), 'ig');
                for (let i in this.views) {
                    if (this.views[i].winObj && winRegexp.test(this.views[i].winObj.name)) {
                        // eslint-disable-next-line no-self-assign
                        this.views[i].winObj.location.href = this.views[i].winObj.location.href;
                    } else if (this.views[i].frameObj && winRegexp.test(this.views[i].frameObj.name)) {
                        // eslint-disable-next-line no-self-assign
                        this.views[i].frameObj.location.href = this.views[i].frameObj.location.href;
                    }
                }
            }
            if (foundedPath && foundedPath.reloadMainGrid) {
                if (typeof this.mainGridReload === 'function') this.mainGridReload(fromWinName, theForm);
            }
        },
        processReturn(fromWinName, theForm) {
            if (this.views[fromWinName]) {
                this.reloadPrevWindow(fromWinName, theForm);
                this.closeView(fromWinName);
            }
        },
        processReturnWoSubmit(fromWinName, theForm) {
            if (this.views[fromWinName]) {
                this.reloadPrevWindow(fromWinName, theForm);
                this.closeView(fromWinName);
            }
        },
        processApply(fromWinName, theForm) {
            if (this.views[fromWinName]) {
                this.reloadPrevWindow(fromWinName, theForm);
                this.closeView(fromWinName);
            }
        },
        checkSessionExist() {
            return true;
        },
        async init() {
            if (typeof PROJECT_WITH_ROUTER !== 'undefined' && window.name.indexOf('System_') !== -1) {
                this.projectWithRouter = true;
                this.availableNavigations = await configStore.getEcNavigation();
                let _self = this;
                window.open = (function (open) {
                    return function (url, windowName, features) {
                        let openedWindow = open.call(window, url, windowName, features);
                        openedWindow.addEventListener('unload', () => {
                            setTimeout(() => {
                                if (openedWindow.closed) {
                                    if (_self.views?.[windowName] && _self.views?.[windowName].openedIn !== 'popup') {
                                        window?.navigationStore?.()?.closeView(windowName);
                                    }
                                }
                            }, 1000);
                        });
                        return openedWindow;
                    };
                }(window.open));
            }
        },
        generateUrl(viewId) {
            let url;
            if (this.views[viewId]) {
                let foundedPath = this.findPath(this.views[viewId]?.config?.windowName);
                if (foundedPath) {
                    url = PROJECTS_URL + 'coordinator/?isNavigationStore=1&';
                    if (typeof USE_PROXY_FOR_NAVIGATION !== 'undefined' && USE_PROXY_FOR_NAVIGATION) {
                        url = 'http://localhost:1025/proxy/coordinator/?isNavigationStore=1&';
                    }
                    let sid = uStore()?.userData?.coordinator?.SID;
                    if (sid) url += 'dis=' + sid + '&';
                    if (foundedPath.staticProps) url += foundedPath.staticProps;
                    for (let i in foundedPath.dynamicProps) {
                        if (!library.objIsEmpty(this.views[viewId].config?.[i])) {
                            url += '&' + i + '=' + this.views[viewId].config?.[i];
                        }
                    }
                }
            }
            return url;
        },
        open(config, winName) {
            if (config && config?.windowName) {
                let foundedPath = this.findPath(config.windowName);
                if (foundedPath) {
                    for (let hiddenInputName in foundedPath.dynamicProps) {
                        if (typeof config?.[hiddenInputName] !== 'undefined') {
                            config.windowName += config[hiddenInputName];
                        }
                    }
                    let viewId = this.createView(config, false, true);
                    this.openIn(viewId, 'popup');
                }
            }
        },
        addToHistory(view) {
            if (!this.projectWithRouter) return;
            let isExists = this.history.find((tmp) => library.isEqualObj(tmp, view));
            if (!isExists) this.history.push(view);
        },
        setWidthAndHeight(viewId) {
            if (this.views[viewId]) {
                let foundedPath = this.findPath(this.views[viewId]?.config?.windowName);
                if (foundedPath) {
                    if (foundedPath.width) this.views[viewId].config.width = foundedPath.width;
                    if (foundedPath.height) this.views[viewId].config.height = foundedPath.height;
                }
            }
        },
        createView(config, openedIn, addToHistory) {
            if (!this.projectWithRouter) return false;
            let viewId;
            for (let tmpViewId in this.views) {
                if (library.isEqualObj(this.views[tmpViewId].config, config)) {
                    viewId = tmpViewId;
                }
            }
            if (!viewId && config.windowName) viewId = config.windowName;
            if (!viewId && config.cId) {
                viewId = config.cId + '_' + config.cType + '_' + JSON.stringify(config);
            }
            if (this.views[viewId]) {
                this.editView(viewId, config);
                if (openedIn) {
                    this.editView(viewId, {
                        openedIn: openedIn
                    });
                }
            } else {
                this.views[viewId] = {
                    viewId: viewId,
                    config: config
                };
                this.views[viewId].openedIn = openedIn || false;
                if (addToHistory) this.addToHistory(config);
            }
            this.views[viewId].url = this.generateUrl(viewId);
            this.setWidthAndHeight(viewId);
            this.calculateUrl();
            return viewId;
        },
        editView(viewId, config) {
            if (!this.projectWithRouter) return;
            if (this.views[viewId]) {
                for (let prop in config) {
                    if (prop === 'openedIn' || prop === 'dialogObj') {
                        this.views[viewId][prop] = config[prop];
                    } else {
                        this.views[viewId].config[prop] = config[prop];
                    }
                }
                this.calculateUrl();
            }
        },
        closeView(viewId) {
            if (!this.projectWithRouter) return;
            let view = this.views[viewId];
            if (view) {
                if (view.openedIn === 'min') return;
                if (view.openedIn === 'popup') {
                    view?.dialogObj?.hide?.();
                }
                if (view.openedIn === 'window') {
                    try {
                        view?.winObj?.close?.();
                    } catch (e) {
                        // do nothing
                    }
                }
                // if popup/window - close
                view.openedIn = false;
                this.calculateUrl();
            }
        },
        async openIn(viewId, type) {
            if (!this.projectWithRouter) return;
            let view = this.views[viewId];
            if (view && view?.config) {
                if (view.openedIn === 'popup') {
                    view?.dialogObj?.hide?.();
                    await library.sleep(1000);
                }
                if (view.openedIn === 'window' && type !== 'window') {
                    view?.winObj?.close?.();
                }
                switch (type) {
                    case 'window':
                        view.openedIn = 'window';
                        if (view.config.cId) {
                            let cConfig = JSON.stringify([this.views[viewId].config]);
                            try {
                                this.views[viewId].winObj = window.open(PROJECTS_URL + 'coordinator/?isNavigationStore=1&componentView=1&components=' + cConfig + '', viewId);
                            } catch (e) {
                                // do nothing
                            }
                        } else {
                            try {
                                this.views[viewId].winObj = window.open(this.views[viewId].url, this.views[viewId].config.windowName, this.views[viewId].config.features);
                            } catch (e) {
                                // do nothing
                            }
                        }
                        break;
                    case 'popup':
                        view.openedIn = 'popup';
                        if (view.config.cId) {
                            actionStore.openComponentDialog({
                                componentId: view.config.cId,
                                componentProps: view.config,
                                cssClass: 'popup-component-wrapper',
                                dialogSettings: {
                                    preventCloseOnBackdropClick: true,
                                    showCloseIcon: true,
                                    closeOnEscape: false,
                                    isComponentDialog: true,
                                    cssClass: 'show-only-content-popup is-for-navigation-store',
                                    funcOpen: (_this) => {
                                        view.dialogObj = _this;
                                    },
                                    funcPostClose: () => {
                                        if (this.views[viewId].openedIn === 'popup') this.closeView(viewId);
                                    }
                                }
                            });
                        } else {
                            this.openIframe(view.url, view.config.windowName, view.config.width, view.config.height);
                        }
                        break;
                    case 'min':
                        view.openedIn = 'min';
                        break;
                    case 'max':
                        view.openedIn = 'max';
                        break;
                }
                this.addToHistory(this.views[viewId].config);
            }
            this.calculateUrl();
        },
        openIframe(url, windowName, width, height) {
            let _self = this;
            let dialogComponent = {
                name: 'iframe-' + windowName,
                template: ''
                    + '<div :id="\'frameWrapper_\' + windowName">'
                    + '<iframe id="' + windowName + '" name="' + windowName + '" ref="' + windowName + '" :src="src" class="same-window-iframe" '
                    + ' frameborder="0" vspace="0" hspace="0" '
                    + ' @load="stopload"></iframe></div> '
                    + '',
                data() {
                    return {
                        windowName: windowName,
                        src: url
                    };
                },
                methods: {
                    stopload(tmpEvent) {
                        if (this?.$refs?.[windowName]?.contentWindow) {
                            _self.views[windowName].frameObj = this?.$refs?.[windowName]?.contentWindow;
                            let titles = this.$refs[windowName].contentWindow.document.querySelectorAll('.profile-title, .account-title, .form-title, .main-title');
                            let newTitles = [];
                            for (let i in titles) {
                                newTitles.push(titles[i].innerText);
                            }
                            let newTitle = '';
                            if (newTitles.length) {
                                newTitle = newTitles.join(' ');
                            }
                            if (!newTitle) {
                                newTitle = this.$refs[windowName].contentWindow.document.title;
                            }
                            if (newTitle) {
                                // eslint-disable-next-line no-use-before-define
                                navigationStore().editView(windowName, { title: newTitle });
                            }
                            let oldClose = this.$refs[windowName].contentWindow.close;
                            this.$refs[windowName].contentWindow.close = function () {
                                // eslint-disable-next-line no-use-before-define
                                if (typeof navigationStore === 'function') navigationStore().closeView(windowName);
                                if (typeof oldClose === 'function') oldClose();
                            };
                        }
                        setTimeout(() => {
                            library.hideLoadingIndicator('frameWrapper_' + this.windowName);
                        }, 1000);
                    }
                }
            };
            library.showDialog(
                dialogComponent,
                false,
                false, {
                    name: windowName,
                    width: width,
                    height: height,
                    title: " ",
                    cssClass: "show-only-content-popup iframe-popup is-for-navigation-store",
                    showNewWindowIcon: true,
                    // resizeElemToPopUpHeight: 'frameWrapper_' + windowName,
                    funcOpen: (dialogObj) => {
                        this.views[windowName].dialogObj = dialogObj;
                        library.showLoadingIndicator('frameWrapper_' + windowName);
                    },
                    funcPostClose: () => {
                        // eslint-disable-next-line no-use-before-define
                        navigationStore().closeView(windowName);
                    }
                }
            );
        },
        restoreUrl() {
            if (!this.projectWithRouter) return;
            if (typeof router?.currentRoute?.value?.query?.ncrc === 'string' && router.currentRoute.value.query.ncrc) {
                this.crc = router.currentRoute.value.query.ncrc;
            }
            sDs.post('sds_getNavigationParams', this.crc, 2).then((response) => {
                if (response.status === 'success' && response.data) {
                    let tmpViews = library.cloneObj(response.data);
                    for (let i in tmpViews?.views) {
                        this.views[i] = tmpViews.views[i];
                        this.views[i].url = this.generateUrl(i);
                        if (tmpViews.views[i].openedIn === 'window' || tmpViews.views[i].openedIn === 'popup') {
                            this.openIn(tmpViews.views[i].viewId, tmpViews.views[i].openedIn);
                        }
                    }
                    if (typeof tmpViews.additionalParams === 'object') this.additionalParams = library.cloneObj(tmpViews.additionalParams);
                }
            });
        },
        setAdditionalParams(additionalParams) {
            if (typeof additionalParams === "object") {
                for (let i in additionalParams) {
                    this.additionalParams[i] = library.cloneObj(additionalParams[i]);
                }
                this.calculateUrl();
            }
        },
        calculateUrl() {
            if (!this.projectWithRouter) return;
            let tmpViews = {
                views: {},
                additionalParams: {}
            };
            for (let i in this.views) {
                if (this.views[i].openedIn) {
                    tmpViews.views[i] = library.cloneObj(this.views[i]);
                    delete tmpViews.views[i].dialogObj;
                    delete tmpViews.views[i].winObj;
                    delete tmpViews.views[i].frameObj;
                    delete tmpViews.views[i].url;
                }
            }
            tmpViews.additionalParams = library.cloneObj(this.additionalParams);
            let saveNavigationParams = () => {
                if (library.isEqualObj(tmpViews, prevSavedViewes)) return;
                sDs.post('sds_setNavigationParams', this.crc, tmpViews, 2).then((response) => {
                    if (response.status === 'success' && response.data && !this.crc) {
                        prevSavedViewes = library.cloneObj(tmpViews);
                        this.crc = response.data;
                        router.push({
                            path: router.currentRoute.value.path,
                            query: { ncrc: this.crc }
                        });
                    }
                });
            };
            if (saveNavigationParamsTimeout) clearTimeout(saveNavigationParamsTimeout);
            saveNavigationParamsTimeout = setTimeout(saveNavigationParams, 5000);
        }
    }
};

const navigationStore = defineStore('navigationStore', navigationStoreOptions);

let getTopNavigationStore = (winObj) => {
    // all manipulation should go in main window
    if (winObj.name.indexOf('System_') !== -1) return navigationStore;
    try {
        if (window.top !== winObj) {
            // iframe
            winObj = window.top;
        } else {
            while (winObj !== window.opener) winObj = window.opener;
        }
        let tmpNavigationStore = winObj?.navigationStore;
        if (!tmpNavigationStore) tmpNavigationStore = false;
        return tmpNavigationStore;
    } catch (e) {
        return false;
    }
};

window.navigationStore = getTopNavigationStore(window);

export { navigationStore };
